const onetwenty = [
  {
    name: '2g-sim',
    type: '120',
    size: '120px'
  },
  {
    name: '3g-sim',
    type: '120',
    size: '120px'
  },
  {
    name: '4g-sim',
    type: '120',
    size: '120px'
  },
  {
    name: 'account-manager',
    type: '120',
    size: '120px'
  },
  {
    name: 'app-advisor',
    type: '120',
    size: '120px'
  },
  {
    name: 'bus-tickets',
    type: '120',
    size: '120px'
  },
  {
    name: 'calls',
    type: '120',
    size: '120px'
  },
  {
    name: 'connections',
    type: '120',
    size: '120px'
  },
  {
    name: 'dashboard',
    type: '120',
    size: '120px'
  },
  {
    name: 'data-connectivity',
    type: '120',
    size: '120px'
  },
  {
    name: 'dnd-activate',
    type: '120',
    size: '120px'
  },
  {
    name: 'dnd-desactivate',
    type: '120',
    size: '120px'
  },
  {
    name: 'ensuring-uninterrupted-services-business',
    type: '120',
    size: '120px'
  },
  {
    name: 'find-rates',
    type: '120',
    size: '120px'
  },
  {
    name: 'get-help',
    type: '120',
    size: '120px'
  },
  {
    name: 'international-roaming',
    type: '120',
    size: '120px'
  },
  {
    name: 'internet',
    type: '120',
    size: '120px'
  },
  {
    name: 'iplc',
    type: '120',
    size: '120px'
  },
  {
    name: 'isd',
    type: '120',
    size: '120px'
  },
  {
    name: 'isd-advanced',
    type: '120',
    size: '120px'
  },
  {
    name: 'itfs',
    type: '120',
    size: '120px'
  },
  {
    name: 'maintenance',
    type: '120',
    size: '120px'
  },
  {
    name: 'messages',
    type: '120',
    size: '120px'
  },
  {
    name: 'network-issues',
    type: '120',
    size: '120px'
  },
  {
    name: 'one-more-product',
    type: '120',
    size: '120px'
  },
  {
    name: 'online-shopping',
    type: '120',
    size: '120px'
  },
  {
    name: 'organization',
    type: '120',
    size: '120px'
  },
  {
    name: 'page-not-found',
    type: '120',
    size: '120px'
  },
  {
    name: 'pay-outstanding-invoices',
    type: '120',
    size: '120px'
  },
  {
    name: 'payment-trends',
    type: '120',
    size: '120px'
  },
  {
    name: 'payment-uncompleted',
    type: '120',
    size: '120px'
  },
  {
    name: 'pharmacy',
    type: '120',
    size: '120px'
  },
  {
    name: 'savings',
    type: '120',
    size: '120px'
  },
  {
    name: 'search-files',
    type: '120',
    size: '120px'
  },
  {
    name: 'second-tv',
    type: '120',
    size: '120px'
  },
  {
    name: 'smart-savings',
    type: '120',
    size: '120px'
  },
  {
    name: 'smartphone-action',
    type: '120',
    size: '120px'
  },
  {
    name: 'thought-leadership-article-on-ddos',
    type: '120',
    size: '120px'
  },
  {
    name: 'upload-tds',
    type: '120',
    size: '120px'
  },
  {
    name: 'whats-next',
    type: '120',
    size: '120px'
  },
  {
    name: 'write',
    type: '120',
    size: '120px'
  },
];

export default onetwenty;



// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/constants/onetwenty.js